import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const qualifiedAction = createAsyncThunk(
    'qualified',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/total-missionqualified`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const qualifiedSlice = createSlice({
    name: 'qualified',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(qualifiedAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(qualifiedAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(qualifiedAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const qualifiedReducer = qualifiedSlice.reducer
